import { useTranslation } from "@opendash/core";
import {
  Descriptions,
  Flex,
  Timeline,
  TimelineItemProps,
  Typography,
} from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import dayjs from "dayjs";
import React, { useMemo } from "react";
import { Message } from "../../../js/parsegenerated";
import { useHideOnPrint } from "../hooks/useHideOnPrint";
import { MessagesContent } from "./MessagesContent";

export const MessagesTile = (props: { messages: Message[] }) => {
  const t = useTranslation();
  const [visibleData, setVisibleData] = React.useState<boolean[]>([]);
  const { className, icon, isVisible, title, toggleIsVisible } = useHideOnPrint(
    false,
    true
  );

  const messagesWithContent = useMemo(() => {
    return props.messages?.filter(messageHasContent);
  }, [props.messages]);

  React.useEffect(() => {
    if (messagesWithContent) {
      const visData: boolean[] = [];
      messagesWithContent.forEach((message) => {
        visData[message.id] = true;
      });
      setVisibleData(visData);
    }
  }, [messagesWithContent]);

  const timelineItems: TimelineItemProps[] = messagesWithContent?.map(
    (message) => {
      return {
        children: (
          <>
            <Typography.Text italic>
              {dayjs(message?.createdAt).format("DD.MM.YYYY HH:mm")}
            </Typography.Text>
            <MessagesContent
              message={message}
              onClick={() => handleVisibleData(message?.id)}
            />
          </>
        ),
        className:
          !isVisible || visibleData[message?.id] === false ? "no-print" : "",
        style: { display: !isVisible ? "none" : "" },
      };
    }
  );

  const timeline = <Timeline items={timelineItems} />;

  function handleVisibleData(messageId: string | number) {
    setVisibleData((prevData) => {
      const newData: boolean[] = [];
      // we have a associative array, meaning we cant use the ... operator
      for (const key in prevData) {
        newData[key] = prevData[key];
      }
      newData[messageId] = !prevData[messageId];
      return newData;
    });
  }

  function messageHasContent(message: Message) {
    return (
      message?.data?.type === "userinput" &&
      (message?.title?.length > 0 || !!message?.content)
    );
  }

  const items: DescriptionsItemType[] = [
    {
      key: 3,
      span: 100,
      label: (
        <Flex
          gap="2vw"
          align="center"
          onClick={() => toggleIsVisible()}
          title={title}
          style={{ cursor: "pointer", userSelect: "none" }}
        >
          <Typography.Text>
            {t(
              "maintenance:monitor.daily_schedule.print.ticket.message.all_title"
            )}
          </Typography.Text>
          {icon}
        </Flex>
      ),
      children: timeline,
      className: className,
    },
  ];

  return (
    <>
      {timelineItems?.length > 0 && (
        <Descriptions
          column={100}
          layout="vertical"
          bordered
          size="small"
          items={items}
        />
      )}
    </>
  );
};
